import { m } from '@/lib/paraglide/messages'

/**
 * Số ảnh tối thiểu để một khuôn mặt dùng được, khớp entity.MinFacePhotos ở
 * backend. Đổi ở đây phải đổi cả bên đó.
 */
export const MIN_FACE_PHOTOS = 3

export type FaceStatus = {
    usable: boolean
    label: string
}

/**
 * Nhãn trạng thái của một khuôn mặt.
 *
 * CỐ Ý không nói số ảnh. Người dùng không quản lý từng tấm: chụp là chụp trọn
 * bộ và thay hết bộ cũ, nên "còn thiếu 1 ảnh" chẳng giúp họ quyết định gì —
 * việc phải làm luôn là chụp lại cả lượt.
 */
export function faceStatus(photoCount: number): FaceStatus {
    const usable = photoCount >= MIN_FACE_PHOTOS
    return {
        usable,
        label: usable
            ? m.face_enroll_registered()
            : m.face_enroll_not_registered(),
    }
}
